import { ENDPOINT } from './meta.api';

const throwApiError = async (r, fallback) => {
    const data = await r.json().catch(() => null);
    throw new Error(data?.message || fallback);
};

export const fetchApiKeys = async () => {
    const r = await fetch(`${ENDPOINT}/user/api-keys`, { method: 'GET' });
    if (!r.ok) await throwApiError(r, `Failed to fetch API keys: ${r.status}`);
    const data = await r.json();
    return data.api_keys;
};

export const createApiKey = async (name) => {
    const r = await fetch(`${ENDPOINT}/user/api-keys`, {
        method: 'POST',
        body: JSON.stringify({ name }),
    });
    if (!r.ok) await throwApiError(r, `Failed to create API key: ${r.status}`);
    return r.json();
};

export const renameApiKey = async (keyId, name) => {
    const r = await fetch(
        `${ENDPOINT}/user/api-keys/${encodeURIComponent(keyId)}`,
        {
            method: 'PATCH',
            body: JSON.stringify({ name }),
        },
    );
    if (!r.ok) await throwApiError(r, `Failed to rename API key: ${r.status}`);
    return r.json();
};

export const deleteApiKey = async (keyId) => {
    const r = await fetch(
        `${ENDPOINT}/user/api-keys/${encodeURIComponent(keyId)}`,
        { method: 'DELETE' },
    );
    if (!r.ok) await throwApiError(r, `Failed to revoke API key: ${r.status}`);
};
